'use strict';

import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TrackingConstants } from '../cfs-search-slice';

import user from '../../../../profile/user';
import analytics from '../../../../utils/analytics';

export const SortOrder = ({ sortOptions }) => {
	const sortOrder = useSelector((state) => state.cfsSearch.sortOrder);
	const userLocation = useSelector((state) => state.cfsSearch.location);

	const [selectedValue, setSelectedValue] = useState('');

	useEffect(() => {
		let value;

		if (sortOrder) {
			value = `${sortOrder.sortBy}|${sortOrder.sortOrder}`;
		}

		if (!value || (sortOrder.sortBy === 'Distance' && !userLocation.latLong && !userLocation.postcode)) {
			// No sort order stored, or its a distance sort without a location set
			value = sortOptions[0].value;
		}

		setSelectedValue(value);
	}, []);

	const onOptionChange = (e) => {
		setSelectedValue(e.target.value);

		analytics.trackEvent(TrackingConstants.Categories.SortOrder, 'Sort order changed', e.target.value);

		const newSortOrder = e.target.value.split('|');
		user.setCfsSortOrder(newSortOrder[0], newSortOrder[1]);
		window.location.reload();
	};

	const content = sortOptions.map((sortOption) => {
		return (
			<li key={sortOption.value} className="search-filter-content__list__item">
				<label className="search-filter-content__list__radio-option">
					<span>{sortOption.displayText}</span>
					<input
						className="search-filter-content__list__radio-option__input"
						type="radio"
						name="sort-order"
						value={sortOption.value}
						checked={selectedValue === sortOption.value}
						onChange={onOptionChange}
					/>
				</label>
			</li>
		);
	});

	return (
		<div className="search-filter-content__list">
			<h3 className="search-filter-content__list__heading">Sort by options</h3>
			<ul className="search-filter-content__list__items">
				{content}
			</ul>
		</div>
	);
}